import { generateClient } from 'aws-amplify/api'
import {
  generateOrgApiKey,
  generateOrgOAuthClient,
} from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

async function runMutation(mutation, input, field) {
  try {
    const { data, errors } = await client.graphql({
      query: mutation,
      variables: { input: input ?? {} },
    })

    const parsed = parseAwsJson(data?.[field])
    if (parsed != null) return parsed

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return { status: 'SUCCESS' }
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Request failed'),
    }
  }
}

export default {
  methods: {
    async generateOrgApiKeyRecord(input = {}) {
      return runMutation(generateOrgApiKey, input, 'generateOrgApiKey')
    },
    async generateOrgOAuthClientRecord(input = {}) {
      return runMutation(generateOrgOAuthClient, input, 'generateOrgOAuthClient')
    },
  },
}
